const cookie = () => JSON.parse(localStorage.getItem("cookie")).token;

export default cookie;
